import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey = 'formsPreviewHeaderText';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  formsPreviewHeaderText: {
    id: 'boxForm.submitter.formsPreviewHeaderText',
    description: 'Text to display when previewing a Form',
    defaultMessage:
      'Preview Mode: Any submissions in preview will not be submitted. Please refresh this page to see the latest saved version of the Form.',
  },
});

export default messages;
